var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"payment-method-header"},[_c('img',{staticClass:"payment-method-header__icon",attrs:{"src":_vm.logoIcon,"alt":"logo"}}),_c('h1',{staticClass:"payment-method-header__title"},[_vm._v(" Select payment method ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }